export default {
  VERTICAL: 'vertical',
  SQUARE: 'square',
  HORIZONTAL: 'horizontal'
};
